/** Phase E-4: OverviewTab + industry sectionLabels — ko/en/vi/ru */

const overviewTab = {
  vsLastMonth: [' vs 지난달', ' vs last month', ' so với tháng trước', ' к прошлому месяцу'],
  viewsToday: ['오늘 조회', 'Views today', 'Lượt xem hôm nay', 'Просмотры сегодня'],
  viewsTotal: ['총 조회', 'Total views', 'Tổng lượt xem', 'Всего просмотров'],
  favorites: ['찜', 'Saves', 'Đã lưu', 'В избранном'],
  inquiries: ['문의', 'Inquiries', 'Liên hệ', 'Запросы'],
  adsAria: ['광고 현황 요약', 'Ads summary', 'Tóm tắt quảng cáo', 'Сводка рекламы'],
  adsTitle: ['광고 현황', 'Advertising', 'Quảng cáo', 'Реклама'],
  adsEmpty: [
    '등록된 캠페인이 없습니다. 광고 탭에서 신규 신청할 수 있습니다.',
    'No campaigns yet. Apply in the Ads tab.',
    'Chưa có chiến dịch. Đăng ký ở tab Quảng cáo.',
    'Нет кампаний. Подайте заявку во вкладке Реклама.',
  ],
  adsActive: ['진행 {n}', 'Active {n}', 'Đang chạy {n}', 'Активно {n}'],
  adsPaused: ['일시정지 {n}', 'Paused {n}', 'Tạm dừng {n}', 'На паузе {n}'],
  adsCompleted: ['완료 {n}', 'Completed {n}', 'Hoàn tất {n}', 'Завершено {n}'],
  adsExpiring: [
    '만료 48시간 이내 캠페인 {n}건 — 광고 탭에서 확인해 주세요.',
    '{n} campaign(s) expiring within 48h — check the Ads tab.',
    '{n} chiến dịch hết hạn trong 48h — xem tab Quảng cáo.',
    '{n} кампаний истекает за 48 ч — вкладка Реклама.',
  ],
  comboAria: ['콤보·할인 요약', 'Combo & discount summary', 'Tóm tắt combo và giảm giá', 'Сводка комбо и скидок'],
  comboTitle: ['콤보 · 시간대할인', 'Combos & time discounts', 'Combo và giảm giá theo giờ', 'Комбо и скидки по времени'],
  comboCount: ['콤보 상품 {n}', 'Combos {n}', 'Combo {n}', 'Комбо {n}'],
  comboActiveDiscounts: ['활성 할인 규칙 {n}', 'Active discounts {n}', 'Giảm giá đang bật {n}', 'Активных скидок {n}'],
  monthBaseline: ['기준 월: {month}', 'Month: {month}', 'Tháng: {month}', 'Месяц: {month}'],
  loadError: ['지표를 불러오지 못했습니다.', 'Could not load metrics.', 'Không tải được chỉ số.', 'Не удалось загрузить метрики.'],
  loadErrorHint: [
    '통계는 준비 중일 수 있어요. 관리 탭에서 프로필을 채우면 노출이 시작됩니다.',
    'Stats may still be preparing. Complete your profile in Manage to start appearing.',
    'Thống kê có thể đang chuẩn bị. Hoàn thiện hồ sơ ở tab Quản lý.',
    'Статистика может готовиться. Заполните профиль во вкладке Управление.',
  ],
};

const defaultLabels = {
  gallery: ['포트폴리오', 'Portfolio', 'Portfolio', 'Портфолио'],
  hours: ['영업시간', 'Business hours', 'Giờ mở cửa', 'Часы работы'],
  options: ['서비스 옵션', 'Service options', 'Tùy chọn dịch vụ', 'Опции услуг'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const travel_activity_experience = {
  gallery: ['투어 갤러리', 'Tour gallery', 'Gallery tour', 'Галерея туров'],
  hours: ['운영·상담 시간', 'Hours & consultation', 'Giờ vận hành & tư vấn', 'Часы и консультации'],
  options: ['투어 옵션', 'Tour options', 'Tùy chọn tour', 'Опции туров'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const accommodation_stay = {
  gallery: ['숙소 사진', 'Property photos', 'Ảnh chỗ ở', 'Фото жилья'],
  hours: ['체크인·체크아웃', 'Check-in & out', 'Nhận/trả phòng', 'Заезд и выезд'],
  options: ['편의시설', 'Amenities', 'Tiện nghi', 'Удобства'],
  price: ['1박 가격(부터)', 'Nightly rate (from)', 'Giá/đêm (từ)', 'Цена за ночь (от)'],
};

const food_cafe_mart = {
  gallery: ['매장·메뉴 사진', 'Store & menu photos', 'Ảnh cửa hàng & menu', 'Фото заведения и меню'],
  hours: ['영업시간', 'Business hours', 'Giờ mở cửa', 'Часы работы'],
  options: ['편의·서비스', 'Amenities & service', 'Tiện ích & dịch vụ', 'Удобства и сервис'],
  price: ['가격대', 'Price range', 'Mức giá', 'Ценовой диапазон'],
};

const living_realestate_rental = {
  gallery: ['매물 사진', 'Listing photos', 'Ảnh bất động sản', 'Фото объекта'],
  hours: ['상담 가능 시간', 'Consultation hours', 'Giờ tư vấn', 'Часы консультаций'],
  options: ['매물 옵션', 'Listing options', 'Tùy chọn BĐS', 'Опции объекта'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const health_medical_beauty = {
  gallery: ['시설·시술 사진', 'Facility & treatment photos', 'Ảnh cơ sở & dịch vụ', 'Фото клиники'],
  hours: ['진료·영업 시간', 'Clinic hours', 'Giờ khám & mở cửa', 'Часы приёма'],
  options: ['진료·시술 항목', 'Treatments', 'Dịch vụ điều trị', 'Процедуры'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const home_interior = {
  gallery: ['시공 사례', 'Project gallery', 'Dự án thi công', 'Примеры работ'],
  hours: ['영업시간', 'Business hours', 'Giờ mở cửa', 'Часы работы'],
  options: ['시공 옵션', 'Build options', 'Tùy chọn thi công', 'Опции работ'],
  price: ['시공가(부터)', 'Build cost (from)', 'Giá thi công (từ)', 'Стоимость (от)'],
};

const education_lesson = {
  gallery: ['수업·시설 사진', 'Class & facility photos', 'Ảnh lớp & cơ sở', 'Фото занятий'],
  hours: ['운영 시간', 'Operating hours', 'Giờ hoạt động', 'Часы работы'],
  options: ['수업 옵션', 'Class options', 'Tùy chọn lớp', 'Опции занятий'],
  price: ['수강료(부터)', 'Tuition (from)', 'Học phí (từ)', 'Стоимость (от)'],
};

const mobility_transport = {
  gallery: ['작업·차량 사진', 'Fleet & work photos', 'Ảnh xe & dịch vụ', 'Фото автопарка'],
  hours: ['운영 시간', 'Operating hours', 'Giờ hoạt động', 'Часы работы'],
  options: ['서비스 옵션', 'Service options', 'Tùy chọn dịch vụ', 'Опции услуг'],
  price: ['요금(부터)', 'Fare (from)', 'Giá (từ)', 'Тариф (от)'],
};

const finance_remittance = {
  gallery: ['사진', 'Photos', 'Ảnh', 'Фото'],
  hours: ['영업시간', 'Business hours', 'Giờ mở cửa', 'Часы работы'],
  options: ['서비스 옵션', 'Service options', 'Tùy chọn dịch vụ', 'Опции услуг'],
  price: ['수수료 안내', 'Fee info', 'Phí dịch vụ', 'Комиссии'],
};

const wedding_event = {
  gallery: ['포트폴리오', 'Portfolio', 'Portfolio', 'Портфолио'],
  hours: ['상담 가능 시간', 'Consultation hours', 'Giờ tư vấn', 'Часы консультаций'],
  options: ['패키지 옵션', 'Package options', 'Tùy chọn gói', 'Опции пакетов'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const pet = {
  gallery: ['시설·사례 사진', 'Facility photos', 'Ảnh cơ sở', 'Фото объекта'],
  hours: ['영업시간', 'Business hours', 'Giờ mở cửa', 'Часы работы'],
  options: ['서비스 옵션', 'Service options', 'Tùy chọn dịch vụ', 'Опции услуг'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const creator_media = {
  gallery: ['포트폴리오', 'Portfolio', 'Portfolio', 'Портфолио'],
  hours: ['작업 가능 시간', 'Availability', 'Giờ làm việc', 'Доступность'],
  options: ['작업 옵션', 'Service options', 'Tùy chọn dịch vụ', 'Опции работ'],
  price: ['단가(부터)', 'Rate (from)', 'Đơn giá (từ)', 'Ставка (от)'],
};

const parenting_care = {
  gallery: ['시설 사진', 'Facility photos', 'Ảnh cơ sở', 'Фото объекта'],
  hours: ['운영 시간', 'Operating hours', 'Giờ hoạt động', 'Часы работы'],
  options: ['돌봄 옵션', 'Care options', 'Tùy chọn chăm sóc', 'Опции ухода'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const jobs_business = {
  gallery: ['회사 사진', 'Company photos', 'Ảnh công ty', 'Фото компании'],
  hours: ['문의 가능 시간', 'Inquiry hours', 'Giờ nhận liên hệ', 'Часы для запросов'],
  options: ['채용 태그', 'Hiring tags', 'Thẻ tuyển dụng', 'Теги найма'],
  price: ['가격(부터)', 'Price (from)', 'Giá (từ)', 'Цена (от)'],
};

const SECTION_LABEL_CATEGORIES = {
  default: defaultLabels,
  travel_activity_experience,
  accommodation_stay,
  food_cafe_mart,
  living_realestate_rental,
  health_medical_beauty,
  home_interior,
  education_lesson,
  mobility_transport,
  finance_remittance,
  wedding_event,
  pet,
  creator_media,
  parenting_care,
  jobs_business,
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function pickSectionLabels(langIndex) {
  const out = {};
  Object.entries(SECTION_LABEL_CATEGORIES).forEach(([cat, fields]) => {
    out[cat] = pick(fields, langIndex);
  });
  return out;
}

function buildLang(langIndex) {
  return {
    dashboard: {
      overviewTab: pick(overviewTab, langIndex),
      sectionLabels: pickSectionLabels(langIndex),
    },
  };
}

export const phaseE4Ko = buildLang(0);
export const phaseE4En = buildLang(1);
export const phaseE4Vi = buildLang(2);
export const phaseE4Ru = buildLang(3);

export function localeForOverview(language) {
  if (language === 'ko') return 'ko-KR';
  if (language === 'vi') return 'vi-VN';
  if (language === 'ru') return 'ru-RU';
  return 'en-US';
}
